import { LastWriteWinsConsistencySchema } from "@referee-fyi/consistency";
import { z } from "zod/v4";
export const Outcomes = [
    "General",
    "Minor",
    "Major",
    "Inspection",
    "InspectionPassed",
    "InspectionFailed",
    "Disabled",
];
export const InactiveOutcomes = ["Inspection"];
export const IncidentOutcomeDisplayNames = {
    General: "General",
    Minor: "Minor",
    Major: "Major",
    Inspection: "Inspection",
    InspectionPassed: "Inspection Passing",
    InspectionFailed: "Inspection Failing",
    Disabled: "Disabled",
};
export const IncidentOutcomeSchema = z.enum(Outcomes).meta({
    id: "IncidentOutcome",
    description: "The referee determined outcome of the incident.",
});
export const IncidentMatchHeadToHeadPeriods = [
    "auto",
    "driver",
    "isolation",
    "interaction",
];
export const IncidentMatchHeadToHeadPeriodSchema = z
    .enum(IncidentMatchHeadToHeadPeriods)
    .meta({
    id: "IncidentMatchHeadToHeadPeriod",
    description: "The period of the match when the incident occurred.",
});
export const IncidentMatchHeadToHeadPeriodDisplayNames = {
    auto: "Auto",
    driver: "Driver",
    isolation: "Isolation",
    interaction: "Interaction",
};
export const IncidentMatchHeadToHeadSchema = z
    .object({
    type: z.literal("match"),
    division: z.number(),
    name: z.string(),
    id: z.number(),
    period: IncidentMatchHeadToHeadPeriodSchema.optional(),
})
    .meta({
    id: "IncidentMatchHeadToHead",
});
export const IncidentMatchSkillsSchema = z
    .object({
    type: z.literal("skills"),
    skillsType: z.enum(["driver", "programming"]),
    attempt: z.number(),
})
    .meta({
    id: "IncidentMatchSkills",
});
export const IncidentMatchSchema = z
    .discriminatedUnion("type", [
    IncidentMatchHeadToHeadSchema,
    IncidentMatchSkillsSchema,
])
    .meta({
    id: "IncidentMatch",
    description: "The match associated with the incident, if applicable.",
});
export const FLAGS = [
    "judge",
    "judge:energy",
    "judge:sportsmanship",
    "coc",
];
export const IncidentFlagSchema = z.enum(FLAGS).meta({
    id: "IncidentFlag",
    description: "Flags that can be applied to an incident.",
});
export const BaseIncidentSchema = z.object({
    id: z.string(),
    time: z.string().meta({
        description: "ISO 8601 timestamp of when the incident occurred.",
    }),
    event: z.string().meta({ description: "Event Code" }),
    match: IncidentMatchSchema.optional(),
    team: z.string().meta({ description: "Team Number" }),
    outcome: IncidentOutcomeSchema,
    rules: z
        .array(z.string())
        .meta({ description: "Cited rules in the violation, in the form <SG1>" }),
    notes: z.string(),
    assets: z.array(z.string()).meta({
        description: "Asset IDs associated with the incident.",
    }),
    flags: z.array(IncidentFlagSchema),
});
export const INCIDENT_IGNORE = ["id", "time", "event", "team"];
export const INCIDENT_INCLUDE = [
    "match",
    "outcome",
    "rules",
    "notes",
    "assets",
    "flags",
];
export const IncidentIgnoreSchema = z.enum(INCIDENT_IGNORE).meta({
    id: "IncidentIgnore",
});
export const IncidentSchema = z
    .intersection(BaseIncidentSchema, z.object({
    consistency: LastWriteWinsConsistencySchema(z.enum(INCIDENT_INCLUDE)),
}))
    .meta({
    id: "Incident",
});
export function incidentMatchNameToString(match) {
    if (!match)
        return "Non-Match";
    switch (match.type) {
        case "match": {
            return match.name;
        }
        case "skills": {
            const display = {
                programming: "Auto",
                driver: "Driver",
            };
            return `${display[match.skillsType]} Skills ${match.attempt}`;
        }
    }
}
//# sourceMappingURL=incident.js.map